import { render } from "./order-maintenance.vue?vue&type=template&id=529871a2"
import script from "./order-maintenance.vue?vue&type=script&lang=js"
export * from "./order-maintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__